import { Box, Heading, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export default function PortalFirmsPage() {
    const {t} = useTranslation();
    return (
            <Box h="100%" w="100%" bgColor="#f6f3ec" overflowY="auto">
                <Box h="10%" w="100%" paddingLeft="10px">
                    <Heading  fontFamily="inherit" fontWeight="bold" color="green.400">
                    {t('guestArea.guestHome.resilienceOfActors')} - {t('guestArea.firmsPortal.title')}
                    </Heading>
                </Box>
                <Box w={"50%"} paddingLeft="10px">
                    <Text>
                    {t('guestArea.firmsPortal.description')}
                    </Text>
                </Box>
                <Box h="10%" w="100%" paddingLeft="10px">
                    {/* MOMENTANEO */}
                    <Heading  fontFamily="inherit" fontWeight="bold" color="green.400" paddingTop={8}>
                    ({t('guestArea.workInProgress')})
                    </Heading>
                </Box>
            </Box>
    );
}